import type { FC } from "react";
import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";

const { carbon } = colorsPalettes;

const Container = styled.div``;
const Title = styled.div`
    height: 16px;
    padding: 24px;
    ${setFontVariant("h5", carbon[500])};
`;
const Content = styled.div`
    ${setFontVariant("body1", carbon[400])};
    width: 352px;
    padding: 24px;
`;
const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px;
`;

interface IDeleteAssetConfirm {
    title: string;
    content: React.ReactNode;
    onClose: VoidFunction;
    isLoading: boolean;
    onDelete: VoidFunction;
    cancelKey?: string;
    deleteKey?: string;
}

export const DeleteAssetConfirm: FC<IDeleteAssetConfirm> = ({
    title,
    content,
    onClose,
    isLoading,
    onDelete,
    cancelKey = "asset.sharing.footer.cancel",
    deleteKey = "common.delete",
}) => {
    return (
        <Container>
            <Title>{title}</Title>
            <Content>{content}</Content>
            <Footer>
                <Button
                    type={"flatDark"}
                    onClick={onClose}
                    isDisabled={isLoading}
                >
                    {translate(cancelKey)}
                </Button>
                <Button
                    type={isLoading ? "primary" : "warning"}
                    onClick={onDelete}
                    isLoading={isLoading}
                    isDisabled={isLoading}
                >
                    {translate(deleteKey)}
                </Button>
            </Footer>
        </Container>
    );
};
